import React from "react";
import { MARQUEE } from "../data/content";
import { AstrolabeGlyph } from "./motifs";

export default function Marquee() {
  const items = [...MARQUEE, ...MARQUEE];
  return (
    <section
      aria-label="Values"
      className="relative bg-terracotta py-6 overflow-hidden select-none border-y border-brass/30"
      data-testid="marquee-strip"
    >
      {/* subtle constellation dots overlay */}
      <div className="pointer-events-none absolute inset-0 opacity-25 constellation-grid" aria-hidden />
      <div className="pointer-events-none absolute inset-y-0 left-0 w-24 bg-gradient-to-r from-terracotta to-transparent z-10" aria-hidden />
      <div className="pointer-events-none absolute inset-y-0 right-0 w-24 bg-gradient-to-l from-terracotta to-transparent z-10" aria-hidden />
      <div className="flex whitespace-nowrap marquee-track w-max relative">
        {items.map((t, i) => (
          <span key={`marquee-${i}-${t}`} className="flex items-center">
            <span className="font-display italic text-ivory text-2xl sm:text-3xl px-6">{t}</span>
            <AstrolabeGlyph size={16} color="#F5D77E" />
          </span>
        ))}
      </div>
    </section>
  );
}
